import { forwardRef, memo } from 'react';
import type { ComponentPropsWithoutRef } from 'react';

import { cx } from '@/utils/cx';

import styles from './CategoryDivider.module.scss';

export type CategoryDividerProps = ComponentPropsWithoutRef<'div'>;

export const CategoryDivider = memo(
  forwardRef<HTMLDivElement, CategoryDividerProps>(({ className, ...rest }, ref) => (
    <div aria-hidden="true" className={cx(styles.divider, className)} ref={ref} role="separator" {...rest} />
  )),
);

CategoryDivider.displayName = 'Category.Divider';
